module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("\r\n<div class=\"row\">\r\n    <div class=\"col-md-6 prop-sublabel\">Decimals</div>\r\n    <div class=\"col-md-3\"><input type=\"text\" value=\"")
    ; __append(escapeFn(numberDecimals))
    ; __append("\" name=\"numberDecimals\"></div>\r\n</div>\r\n<div class=\"row\">\r\n    <div class=\"col-md-6 prop-sublabel\">Decimal Separator</div>\r\n    <div class=\"col-md-3\">\r\n        <select name=\"numberDecimalSeparator\" id=\"numberDecimalSeparator\" >\r\n            <option value=\"period\">.</option>\r\n            <option value=\"comma\">,</option>\r\n        </select>\r\n    </div>\r\n</div>\r\n<div class=\"row\">\r\n    <div class=\"col-md-6 prop-sublabel\">Symbol</div>\r\n    <div class=\"col-md-3\"><input type=\"text\" value=\"")
    ; __append(escapeFn(numberSymbol))
    ; __append("\" name=\"numberSymbol\"></div>\r\n</div>\r\n<div class=\"row\">\r\n    <div class=\"col-md-6 prop-sublabel nopadding-r\">Thousand Separator</div>\r\n    <div class=\"col-md-3\">\r\n        <select name=\"numberThousandSeparator\" id=\"numberThousandSeparator\" >\r\n            <option value=\"none\"></option>\r\n            <option value=\"period\">.</option>\r\n            <option value=\"comma\">,</option>\r\n            <option value=\"apostrophe\">'</option>\r\n        </select>\r\n    </div>\r\n</div>")
  }
  return __output;

}